import Url from 'environment';
import Api from '../../api';
import autobind from 'autobind-decorator';
import { DeviceUtil } from '../../../utils/deviceUtil';

@autobind
class NamedSportsService extends Api {
  constructor() {
    super();
  }

  /**
   * @description 응원하기 댓글
   * @param {*} gameId
   * @param {*} sportsId
   * @param {*} homePage
   * @param {*} awayPage
   * @returns
   */
  getSportsMatchComment(gameId, sportsId, homePage, awayPage) {
    return this.commonAjax(
      'get',
      Url.named,
      `sport/comment?game_id=${gameId}&sports_id=${sportsId}&home_page=${homePage}&away_page=${awayPage}`,
      {},
      true
    );
  }

  /**
   * @description 응원하기 댓글 등록
   * @param {*} gameId
   * @param {*} sportsId
   * @param {*} content
   * @param {*} homeAway
   * @param {*} image
   * @returns
   */
  postSportsMatchComment(gameId, sportsId, content, homeAway, image) {
    const form = new FormData();
    form.append('game_id', gameId);
    form.append('sports_id', sportsId);
    form.append('content', content);
    form.append('device', 'WEB');
    form.append('home_away', homeAway);

    return this.commonAjax('post', Url.named, `sport/comment`, form, {}, true);
  }
}

export default new NamedSportsService();
